import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  isFromAuth: string | boolean | undefined;
}

const initialState: AuthState = {
  isAuthenticated: Cookies.get("token") ? true : false,
  token: Cookies.get("token") ?? null,
  isFromAuth: Cookies.get("isFromAuth") ? Cookies.get("isFromAuth") : false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(
      state,
      action: PayloadAction<{
        authToken: string;
        isFromAuth: any
      }>
    ) {
      state.isAuthenticated = true;
      state.token = action.payload.authToken;
      state.isFromAuth = action.payload.isFromAuth;

      const tokenPayload = JSON.parse(
        atob(action.payload.authToken.split(".")[1])
      );
      const expiresIn = tokenPayload.exp * 1000 - Date.now();

      // Set cookie with expiration time
      Cookies.set("token", action.payload.authToken, {
        expires: expiresIn / (1000 * 60 * 60 * 24),
      });
      Cookies.set("isFromAuth", action.payload.isFromAuth, {
        expires: expiresIn / (1000 * 60 * 60 * 24),
      });
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
      state.isFromAuth = false;

      Cookies.remove("token");
      Cookies.remove("isFromAuth");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
